module.exports = __webpack_public_path__ + "img/logo-login.668a03d6.png";